import lodashGet from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

export const getWithNull = (object, path, defaultValue) => {
  const value = lodashGet(object, path, defaultValue);

  return isEmpty(value) ? defaultValue : value;
};
